// src/utils/namehash.ts
import { ens_normalize } from "@adraffy/ens-normalize";
import { namehash, toHex } from "viem";
var normalize = (name) => name ? ens_normalize(name) : name;
function tldNamehash(inputName, identifier) {
  if (!identifier)
    return namehash(inputName);
  const fullNameNode = `${inputName}.[${toHex(identifier, { size: 32 }).slice(2)}]`;
  return namehash(fullNameNode);
}

export {
  normalize,
  tldNamehash
};
